export enum DataTypeEnum {
	String = 'String',
	Character = 'Character',
	Integer = 'Integer',
	Long = 'Long',
	BigDecimal = 'BigDecimal',
	Currency = 'Currency',
	Percentage = 'Percentage',
	Date = 'Date',
	Timestamp = 'Timestamp',
	Time = 'Time',
	Address = 'Address',
	Boolean = 'Boolean',
	URL = 'URL',
}

export enum NumericDataTypeEnum {
	Integer = 'Integer',
	Long = 'Long',
	BigDecimal = 'BigDecimal',
	Currency = 'Currency',
	Percentage = 'Percentage',
}

export interface DataType {
	name: DataTypeEnum;
	scale?: number;
}

const dataTypeZeroValue: Map<DataTypeEnum, string> = new Map<
	DataTypeEnum,
	string
>([
	[DataTypeEnum.BigDecimal, '0.0'],
	[DataTypeEnum.Currency, '0.0'],
	[DataTypeEnum.Percentage, '0.0'],
	[DataTypeEnum.Integer, '0'],
	[DataTypeEnum.Long, '0'],
]);

/**
 * getZeroValueForDataType returns the zero/empty/blank value a field should have
 * when it's a certain data type.
 */
export function getZeroValueForDataType(type: DataTypeEnum): string {
	const r = dataTypeZeroValue.get(type);
	if (r === undefined) {
		return '';
	}
	return r;
}

export const DATA_TYPES_WITH_SCALE = [
	DataTypeEnum.BigDecimal,
	DataTypeEnum.Currency,
	DataTypeEnum.Percentage,
];
